import { render } from "./index.vue?vue&type=template&id=26a2372c&scoped=true"
const script = {}

import "./index.scss?vue&type=style&index=0&id=26a2372c&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/spark-cabinet-redesigned/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26a2372c"]])

export default __exports__